import { Component, inject } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs/operators'

@Component({
  standalone: false,
  selector: 'app-cyborg',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  private router = inject(Router)

  private lastPath: string | null = null

  constructor() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        const path = e.urlAfterRedirects.split(/[?#]/)[0]
        if (this.lastPath !== path) {
          window.scrollTo(0, 0)
          this.lastPath = path
        }
      })
  }
}
